<template>
	<ViewUiCalloutIcon
		class="view-ui-state-comingsoon"
		iconFilename="chalkysticks.svg"
		v-bind:message="'<strong>Stay tuned</strong><br />' + featureName + ' is coming soon'"
	/>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/State
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiStateComingSoon extends ViewBase {
		/**
		 * @type string
		 */
		@Prop({ default: 'Feature' })
		public featureName!: string;
	}
</script>

<style lang="scss">
	.view-ui-state-comingsoon {
		aspect-ratio: auto;
		margin: 0;
	}
</style>
